export enum Fields {
    Email = 'email',
    ConfirmEmail = 'confirmEmail',
    Password = 'password',
    ConfirmPassword = 'confirmPassword',
    FirstName = 'firstName',
    LastName = 'lastName',
    Address1 = 'address1',
    Address2 = 'address2',
    PostalCode = 'postalCode',
    City = 'city',
    CountryCode = 'countryCode',
    Phone = 'phoneMobile',
    Gender = 'gender',
    CreateAccountConsent = 'createAccountConsent',
    CreateAccount = 'createAccount',
    Consent = 'Consent',
    SameDeliveryAddress = 'SameDeliveryAddress',
    UseAsShipping = 'useAsShipping',
    NewsLetterSignup = 'NewsLetterSignup',
    StoreZip = 'storeZip',
    AdultConfirm = 'AdultConfirm',
}

export type ClickAndReserveInputs = {
    [Fields.FirstName]: string;
    [Fields.LastName]: string;
    [Fields.Email]: string;
    [Fields.Phone]: string | number;
};
export type CustomerInformationInputs = {
    [Fields.Email]: string;
    [Fields.ConfirmEmail]: string;
    [Fields.Password]: string;
    [Fields.ConfirmPassword]: string;
    [Fields.FirstName]: string;
    [Fields.LastName]: string;
    [Fields.Address1]: string;
    [Fields.Address2]: string;
    [Fields.PostalCode]: string;
    [Fields.City]: string;
    [Fields.CountryCode]: string;
    [Fields.Phone]: number | string;
    [Fields.CreateAccount]: boolean;
    [Fields.CreateAccountConsent]: boolean;
    [Fields.Consent]: boolean;
    [Fields.UseAsShipping]: boolean;
    [Fields.NewsLetterSignup]: boolean;
    [Fields.AdultConfirm]: boolean;
    [Fields.Gender]: string;
};
export type InstoreInformationInputs = {
    [Fields.Email]: string;
    [Fields.FirstName]: string;
    [Fields.LastName]: string;
    [Fields.Address1]: string;
    [Fields.Address2]: string;
    [Fields.PostalCode]: string;
    [Fields.City]: string;
    [Fields.Phone]: string | number;
    [Fields.StoreZip]?: string;
    [Fields.Gender]: string;
};

export type BaseDeliveryAddress = {
    [Fields.FirstName]: string;
    [Fields.LastName]: string;
    [Fields.Address1]: string;
    [Fields.Phone]: string | number;
    [Fields.Address2]: string;
    [Fields.City]: string;
    countryCode: string;
    carrier?: { id?: string };
    postalCode: string;
    phone?: string | number;
    _id: string;
    deliveryType: 'store' | 'alternative' | 'droppoint';
};

export type StoreDeliveryAddress = BaseDeliveryAddress & {
    deliveryType: 'store';
    storeId: string;
};

export type DropPointDeliveryAddress = BaseDeliveryAddress & {
    deliveryType: 'droppoint';
    storeId?: string;
    carrierCode: string;
};

export type AlternativeDeliveryAddress = BaseDeliveryAddress & {
    deliveryType: 'alternative';
    carrierCode: string;
};

//  A resolved delivery address. Discriminated on `deliveryType`, so a check like
// `deliveryAddress?.deliveryType === 'store'` narrows to StoreDeliveryAddress (with `storeId`).

export type DeliveryAddress =
    | StoreDeliveryAddress
    | DropPointDeliveryAddress
    | AlternativeDeliveryAddress;

export type DeliveryAddressForm = BaseDeliveryAddress & {
    [Fields.SameDeliveryAddress]: boolean;
};

export type StoreDeliveryAddressPayload = {
    _type: 'store';
    id: string;
    name: string;
    address1: string;
    address2: string;
    city: string;
    countryCode: string;
    postalCode: string;
    zip?: string;
};

export type PayloadDeliveryAddress = {
    name: string;
    firstName: string;
    lastName: string;
    address1: string;
    address2: string;
    phoneMobile: string;
    phone?: string | number;
    city: string;
    countryCode: string;
    zip: string;
    postalCode: string;
    _id: string;
    id: string;
    _type?: 'droppoint';
    dropPointId?: string;
    carrierCode: string;
};

export type DeliveryAddressOptionProps = JSX.IntrinsicAttributes & {
    onSubmit: () => void;
    shipmentId: string;
    numberOfShipments: number;
    currentShipmentIndex: number;
    showPreviousShipment: () => void;
};

export type SummaryFormAddress = {
    getValues?: () => Record<string, any>;
    isValid?: boolean;
};
